import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule, Type } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreDirectivesModule } from '@app/directives/_core/_core.directives.module';
import { FormsDirectivesModule } from '@app/directives/_forms/_form.directives.module';
import { VTableModule } from '@app/directives/_layout/v-table/v-table.module';
import { VisualisationsModule } from "@app/directives/_visualisations/visualisations.module";
import { GroupsModule } from '@app/main/components/resourceManagement/groups/groups.module';
import { ResourceManagementModule } from '@app/main/components/resourceManagement/resourceManagement.module';
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MapDirectivesModule } from "@directives/_map/_map.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "@directives/_resourceFilters/_resourceFilters.directives.module";
import { VehicleDirectivesModule } from "@directives/_vehicle/_vehicle.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { PipesModule } from 'src/app/_pipes/_pipes.module';
import { EBPMSScoreHistoryGraphComponent } from "./_components/ebpms/ebpms-score-history-graph/ebpms-score-history-graph.component";
import { EBPMSScoreHistoryTableComponent } from "./_components/ebpms/ebpms-score-history-table/ebpms-score-history-table.component";
import { EBPMSStatusIconComponent } from "./_components/ebpms/ebpms-status-icon/ebpms-status-icon.component";
import { EBPMSStatusSummaryComponent } from "./_components/ebpms/ebpms-status-summary/ebpms-status-summary.component";
import { EBPMSVehicleHistoryComponent } from "./_components/ebpms/ebpms-vehicle-history/ebpms-vehicle-history.component";
import { EBPMSService } from "./_components/ebpms/ebpms.service";
import { FaultCodeVehicleHistoryComponent } from "./_components/faultCodes/_components/fault-code-vehicle-history/fault-code-vehicle-history.component";
import { MaintenanceOverviewComponent } from "./_components/maintenance-overview/maintenance-overview.component";
import { MaintenanceVehicleSummaryComponent } from "./_components/maintenance-vehicle-summary/maintenance-vehicle-summary.component";
import { SensorDataHistoryComponent } from "./_components/sensorData/_components/sensor-data-history/sensor-data-history.component";
import { SensorDataComponent } from "./_components/sensorData/_components/sensor-data/sensor-data.component";
import { VorEditorComponent } from "./_components/vor/vor-editor/vor-editor.component";
import { VorVehicleHistoryComponent } from "./_components/vor/vor-vehicle-history/vor-vehicle-history.component";
import { EndVorCellComponent } from './_components/vor/vor-vehicle-history/end-vor-cell/end-vor-cell.component';

const privateComponents: Type<any>[] = [

];

const publicComponents: any[] = [
    MaintenanceOverviewComponent,
    MaintenanceVehicleSummaryComponent,

    EBPMSStatusIconComponent,
    EBPMSStatusSummaryComponent,
    EBPMSScoreHistoryGraphComponent,
    EBPMSScoreHistoryTableComponent,
    EBPMSVehicleHistoryComponent,

    FaultCodeVehicleHistoryComponent,

    VorVehicleHistoryComponent,
    VorEditorComponent,
    EndVorCellComponent,

    SensorDataComponent,
    SensorDataHistoryComponent
];

const declarations: Type<any>[] = [
];

const providers: any[] = [
    EBPMSService
];

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        ScrollingModule,
        CoreDirectivesModule,
        HttpClientModule,
        BrowserAnimationsModule,
        PipesModule,
        VeriDirectivesModule,
        ResourceFiltersDirectivesModule, // for resource filters
        LayoutDirectivesModule, // for empty state
        VehicleDirectivesModule, //vehicle-reg
        MiscDirectivesModule, // loading indicator
        MapDirectivesModule,// for maps
        FormsDirectivesModule,
        VTableModule,
        ResourceManagementModule,
        GroupsModule,


        FormsModule,
        VisualisationsModule,
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class MaintenanceModule {
    constructor() {
    }
}
